module.exports = {
  DR: { api: 'DR', human: 'Dr.' },
  PROF: { api: 'PROF', human: 'Prof.' },
  PROF_DR: { api: 'PROF_DR', human: 'Prof. Dr.' }
}
